// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>We are working to give Veterans control of their information – their service history, Veteran status, discharge information, and more – and letting them control who sees it. And, we’re working with government agencies and industry partners to help Veterans put their information to work.</p>
      <p>Note: The Address Validation service is for internal VA use only. If you would like to request access, please email <a href="mailto:api@va.gov?Subject=Request%20for%20Address%20Validation%20Access">api@va.gov</a>.</p>
    </div>
  );
};

export default MarkdownComponent;
